import { FunctionComponent } from "react";

import { Route, Routes } from "react-router-dom";

import { FeatureRoute } from "@/components/FeatureRoute/FeatureRoute";
import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

import { WebhookDeliveriesRoute } from "@/pages/Private/pages/Company/pages/WebhookOverview/deliveries/WebhookDeliveries";

import { IntegrationsCatalog } from "./components/IntegrationsCatalog";
import { IntegrationDetail } from "./components/IntegrationDetail";

export const Integrations: FunctionComponent = () => {
	return (
		<Routes>
			<Route element={<IntegrationsCatalog />} index />

			<Route element={<FeatureRoute feature={FeaturesCodes.HUBSPOT} />}>
				<Route element={<IntegrationDetail provider="hubspot" />} path="hubspot/*" />
			</Route>
			<Route element={<FeatureRoute feature={FeaturesCodes.ZOHO_CRM} />}>
				<Route element={<IntegrationDetail provider="zoho" />} path="zoho/*" />
			</Route>
			<Route element={<FeatureRoute feature={FeaturesCodes.PIPEDRIVE_CRM} />}>
				<Route element={<IntegrationDetail provider="pipedrive" />} path="pipedrive/*" />
			</Route>
			<Route element={<FeatureRoute feature={FeaturesCodes.MSDYNAMICS_CRM} />}>
				<Route element={<IntegrationDetail provider="msdynamics" />} path="msdynamics/*" />
			</Route>
			<Route element={<FeatureRoute feature={FeaturesCodes.SALESFORCE_CRM} />}>
				<Route element={<IntegrationDetail provider="salesforce" />} path="salesforce/*" />
			</Route>
			<Route element={<FeatureRoute feature={FeaturesCodes.MCP_ACCESS} />}>
				<Route element={<IntegrationDetail provider="mcp" />} path="mcp/*" />
			</Route>
			<Route element={<IntegrationDetail provider="lemlist" />} path="lemlist/*" />
			<Route element={<IntegrationDetail provider="n8n" />} path="n8n/*" />
			<Route element={<IntegrationDetail provider="api" />} path="api/*" />
			<Route element={<WebhookDeliveriesRoute />} path="webhooks/:webhookId/deliveries" />
			<Route element={<IntegrationDetail provider="webhooks" />} path="webhooks/*" />
		</Routes>
	);
};
